import React from "react";
import { useTranslation } from "react-i18next";
import LandingHeader from "../components/Landing/sections/LandingHeader.jsx";
import LandingNav from "../components/Landing/sections/LandingNav.jsx";
import LandingFooter from "../components/Landing/sections/LandingFooter.jsx";
import "../styles/new-landing.css";

import { useEffect } from "react";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

const Partners = () => {
  const { t } = useTranslation();
  useRestoreScroll();

  useEffect(() => {
    document.body.style.overflow = "";
    document.body.style.overflowY = "";
    return () => {
      document.body.style.overflow = "";
      document.body.style.overflowY = "";
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <LandingHeader />
      <LandingNav />
      <div className="partners-container">
        <div className="partners-header">
          <h1>{t("partners.header.title")}</h1>
          <p>{t("partners.header.subtitle")}</p>
        </div>
        <div className="partners-coming-soon">
          <div className="partners-soon-icon">🤝</div>
          <h2>{t("partners.comingSoon.title")}</h2>
          <p>{t("partners.comingSoon.description")}</p>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default Partners;
